var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _circle, _circle2, _circle3, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _circle4, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgHeroRight = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 896,
    height: 747.971,
    viewBox: "0 0 896 747.971",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2f2e41",
    d: "M41.634 712.738c12.428 23.049 38.806 32.943 38.806 32.943s6.227-27.475-6.201-50.524-38.806-32.944-38.806-32.944-6.227 27.476 6.201 50.525"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#be1622",
    d: "M50.177 705.155c22.438 13.5 31.08 40.314 31.08 40.314s-27.738 4.927-50.177-8.573S0 696.582 0 696.582s27.738-4.927 50.177 8.573"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "M413.248 35.908h140v2h-140z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "M513.249 37.408h2v18.5h-2zM452.248 37.408h2v18.5h-2zM484.248 131.908h140v2h-140z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "M522.249 113.908h2v18.5h-2zM583.249 113.908h2v18.5h-2zM670.249 176.908h140v2h-140z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "M708.249 158.908h2v18.5h-2zM769.249 158.908h2v18.5h-2zM656.249 640.908h140v2h-140z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "M694.249 622.908h2v18.5h-2zM755.249 622.908h2v18.5h-2zM417.248 319.908h140v2h-140z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "M455.248 301.908h2v18.5h-2zM516.249 301.908h2v18.5h-2zM461.248 560.908h140v2h-140z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "M499.248 542.908h2v18.5h-2zM560.249 542.908h2v18.5h-2zM685.249 487.908h140v2h-140z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "M723.249 469.908h2v18.5h-2zM784.249 469.908h2v18.5h-2z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f2e41",
    d: "M362.06 702.184H125.274v-1.703h235.082v-82.62H145.18l-10.453-21.777 1.536-.737 9.989 20.81H362.06z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 156.789,
    cy: 726.033,
    r: 17.887,
    fill: "#3f3d56"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 333.101,
    cy: 726.033,
    r: 17.887,
    fill: "#3f3d56"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 540.927,
    cy: 346.153,
    r: 11.073,
    fill: "#3f3d56"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f2e41",
    d: "M387.385 589.753H121.237L63.648 401.517h383.045l-.349 1.107Zm-264.888-1.703h263.639l58.234-184.83H65.95Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "M366.61 579.958H132.842L82.26 413.015h336.441l-.306.983z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f2e41",
    d: "m451.465 384.7-1.647-.437 11.241-42.369h65.389v1.704H462.37zM82.258 458.584h345.293v1.704H82.258zM101.459 521.344h306.319v1.704H101.459z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f2e41",
    d: "M254.314 402.368h1.704v186.533h-1.704zM320.057 588.844l12.229-186.529 1.7.112-12.228 186.528zM176.38 402.424l1.7-.11 12.158 186.532-1.7.111zM0 745h896v2H0z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#a0616a",
    d: "M595.41 61.876s14.62 41.606 5.623 48.007 30.361 58.676 30.361 58.676l47.23-12.802-25.864-43.74s-3.374-43.74-3.374-50.141-53.975 0-53.975 0"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M595.41 61.876s14.62 41.606 5.623 48.007 30.361 58.676 30.361 58.676l47.23-12.802-25.864-43.74s-3.374-43.74-3.374-50.141-53.975 0-53.975 0",
    opacity: 0.1
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f2e41",
    d: "M570.874 358.454s-4.268 53.341 0 81.079 10.668 104.549 10.668 104.549 0 145.089 23.47 147.222 40.54 4.268 42.673-4.267-10.668-12.802-4.267-17.07 8.535-19.202 0-36.271 0-189.896 0-189.896l40.54 108.817s4.267 89.613 8.534 102.415-4.267 36.272 10.668 38.406 32.005-10.668 40.54-14.936-12.802-4.267-8.535-6.4 17.07-8.535 12.802-10.669-8.535-104.55-8.535-104.55-11.735-218.699-26.67-227.233-24.537 6.165-24.537 6.165Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f2e41",
    d: "M609.28 682.77v17.069s-19.203 46.4 0 46.4 34.138 4.808 34.138-1.593v-57.61ZM735.165 682.74v17.069s19.203 46.399 0 46.399-34.138 4.808-34.138-1.593v-57.608Z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 625.282,
    cy: 54.408,
    r: 38.406,
    fill: "#a0616a"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#be1622",
    d: "M613.547 125.886s10.668 32.004 27.737 25.604l17.07-6.401 29.87 204.83s-23.47 34.139-57.608 12.802-17.07-236.835-17.07-236.835"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f3d56",
    d: "m643.418 119.485 9.601-20.27s56.542 26.67 65.077 35.205 8.534 21.337 8.534 21.337l-14.935 53.341s4.267 117.351 4.267 121.619 14.936 27.737 4.267 19.202-12.801-17.069-21.336-4.267-27.738 27.738-27.738 27.738Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#a0616a",
    d: "m718.096 273.108-6.401 59.742s-38.406 34.139-29.871 36.272 12.802-6.4 12.802-6.4 14.935 14.935 23.47 6.4 29.871-89.613 29.871-89.613Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f2e41",
    d: "M626.1.13c-8.514-.305-17.625-.455-24.804 4.133a36.3 36.3 0 0 0-8.572 8.392c-6.992 8.838-13.033 19.959-10.436 30.925l3.016-1.176a19.75 19.75 0 0 1-1.905 8.462c.425-1.235 1.848.762 1.467 2.011l-3.323 10.9c5.462-2.002 12.257 2.053 13.088 7.81.38-12.66 1.693-27.18 11.964-34.593 5.18-3.739 11.735-4.88 18.042-5.893 5.818-.935 11.918-1.827 17.49.088s10.32 7.615 9.056 13.371c2.57-.885 5.443.906 6.713 3.309s1.337 5.237 1.375 7.955c2.74 1.936 5.857-1.908 6.973-5.071 2.62-7.424 4.95-15.328 3.538-23.073s-7.724-15.148-15.597-15.174a5.47 5.47 0 0 0 1.422-3.849l-6.49-.548a7.17 7.17 0 0 0 4.287-2.26C650.798 8.716 630.314.28 626.1.13"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f3d56",
    d: "M624.215 113.084s-17.37-17.021-23.62-15.979-14.786 15.979-14.786 15.979-51.207 17.069-49.074 34.138 25.604 100.282 25.604 100.282 19.203 100.282 2.134 110.95 81.079 38.406 83.212 25.604 6.401-140.821 0-160.024-23.47-110.95-23.47-110.95M698.893 147.222h26.383s18.424 81.08 20.557 89.614 6.401 49.074 4.268 49.074-44.807-8.535-44.807-2.134Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "M698 348H597c-9.856-45.34-10.68-89.146 0-131h101c-16.3 41.1-17.318 84.607 0 131"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#a0616a",
    d: "m555.938 292.31 29.871 12.803s57.609 8.534 57.609-14.936-57.609-10.668-57.609-10.668l-19.204-6.14Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f3d56",
    d: "m562.339 134.42-25.604 6.401-19.203 113.084s-6.4 29.871 4.268 32.005 40.539 19.203 40.539 19.203 4.267-32.005 12.802-32.005l-21.337-17.07 12.802-74.677Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "M60.248 352.908h140v2h-140z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "M98.249 334.908h2v18.5h-2zM159.249 334.908h2v18.5h-2zM109.249 56.908h140v2h-140z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "M209.249 58.408h2v18.5h-2zM148.249 58.408h2v18.5h-2zM250.249 253.908h140v2h-140z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "M350.248 255.408h2v18.5h-2zM289.248 255.408h2v18.5h-2zM12.248 252.908h140v2h-140z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "M112.249 254.408h2v18.5h-2zM51.248 254.408h2v18.5h-2zM180.249 152.908h140v2h-140z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "M218.249 134.908h2v18.5h-2zM279.248 134.908h2v18.5h-2z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHeroRight);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/hero-right.7705fff6.svg";